import React from "react";
import { ShieldCheck, UserCheck, PlaneTakeoff, Headphones } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

const icons = [ShieldCheck, UserCheck, PlaneTakeoff, Headphones];

const Trust = () => {
  const { t } = useLang();
  return (
    <section
      id="about"
      data-testid="trust-section"
      className="py-24 sm:py-32 bg-[#F9F6F0]"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-12">
        <p className="text-[#2E4F4F] text-xs uppercase tracking-[0.3em] mb-12">
          {t.trust.eyebrow}
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-[#1A1F24]/10">
          {t.trust.items.map((item, i) => {
            const Icon = icons[i];
            return (
              <div
                key={item.title}
                data-testid={`trust-item-${item.title}`}
                className="bg-[#F9F6F0] p-8 sm:p-10"
              >
                <Icon className="w-7 h-7 text-[#2E4F4F] mb-6" strokeWidth={1.5} />
                <h3 className="font-serif text-xl sm:text-2xl text-[#1A1F24] mb-3">
                  {item.title}
                </h3>
                <p className="text-sm text-[#4A5568] leading-relaxed">
                  {item.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Trust;
